import WindowedTable from "./WindowedTable";
export default WindowedTable;
